/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectItemCommand } from '../../models/update-project-item-command';
import { UpdateProjectItemCommandResult } from '../../models/update-project-item-command-result';

export interface ApiProjectItemUpdateProjectItemPatch$Params {
      body?: UpdateProjectItemCommand
}

export function apiProjectItemUpdateProjectItemPatch(http: HttpClient, rootUrl: string, params?: ApiProjectItemUpdateProjectItemPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemUpdateProjectItemPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectItemCommandResult>;
    })
  );
}

apiProjectItemUpdateProjectItemPatch.PATH = '/api/ProjectItem/UpdateProjectItem';
